<app-sidebar-wrapper [(isOpen)]="isOpen">
  <div class="sidebar__content">
    <ul class="sidebar__content_list menu">
      @for (menu of menus(); track $index) {
        <li class="menu__item">
          @if (menu.route) {
            <a
              class="menu__item_link"
              [tabIndex]="isOpen() ? 0 : -1"
              (click)="menu['action']?.()"
              [routerLink]="menu.route"
            >
              <i class="icon" [ngClass]="[menu.icon]"></i>
              <span class="menu__item_link_text">{{ menu.name }}</span>
            </a>
          } @else {
            <button
              class="menu__item_link"
              type="button"
              [tabIndex]="isOpen() ? 0 : -1"
              (click)="menu['action']?.()"
            >
              <i class="icon" [ngClass]="[menu.icon]"></i>
              <span class="menu__item_link_text">{{ menu.name }}</span>
            </button>
          }
        </li>
      }
    </ul>

    @if (headerLinks.length > 0) {
      <ul class="sidebar__content_list menu menu--header-links">
        @for (link of headerLinks; track link.url) {
          <li class="menu__item">
            <a
              class="menu__item_link"
              [href]="link.url"
              target="_blank"
              rel="noopener noreferrer"
              [tabIndex]="isOpen() ? 0 : -1"
              (click)="isOpen.set(false)"
            >
              <i class="icon icon-arrow-top-right"></i>
              <span class="menu__item_link_text">{{ link.label }}</span>
            </a>
          </li>
        }
      </ul>
    }
  </div>
</app-sidebar-wrapper>
